const appSettings = {
  ENVIRONMENT_NAME: 'demo',
  SIGNOZ_TOKEN: 'Z3HAHc4YSVaRN2lgXLu2OrMcdutt7c3shSE-', //gitleaks:allow //trufflehog:ignore
  SERVICE_VERSION: 'c26d1588e6c926d820ee77dd7de7ffd7f55b7361-demo',
  STACKDRIVER_API_KEY: 'AIzaSyAnL1trIr6wVSkKXoju2JBD_AdAMNflWhM', //gitleaks:allow //trufflehog:ignore
  STACKDRIVER_LOGGING_ENABLED: true,
  GOOGLE_PROJECT_ID: '38104635069',
  GRAPHQL_SERVER_URL: 'https://api-demo.spoileralert.com/admin/',
  REFRESH_URL: 'https://admin-demo.spoileralert.com/version',
  GOOGLE_MAPS_VERSION: '3.37',
  DATABASE_RESET_PROFILE: 'demo',
};

export default appSettings;
